import AppTooltip from "components/shared/CommonTooltip";
import { useMemo } from "react";
import { ProgressBar, Spinner } from "react-bootstrap";

const ExportProgress = ({ data }) => {
  const { completed = 0, failed = 0, total = 1 } = data || {};

  const { completedPercent, failedPercent } = useMemo(() => {
    const completedPercent = Math.min(Math.round((completed / total) * 100), 99);
    const failedPercent = Math.min(Math.round((failed / total) * 100), 99);
    return { completedPercent, failedPercent };
  }, [completed, failed, total]);

  const tooltipText =
    completed + failed < total
      ? `${completed} of ${total} clients exported${failed ? ` (${failed} failed)` : ''}`
      : "Finalizing export...";

  if(completed + failed < 1) {
    return null;
  }

  return (
    <AppTooltip text={tooltipText} placement="top">
      <div className="pb-2 position-relative">
        <ProgressBar>
          <ProgressBar now={completedPercent} variant="success" label={`${completedPercent}%`} key={1} />
          {failed > 0 && <ProgressBar now={failedPercent} variant="danger" label={`${failedPercent}%`} key={2} />}
        </ProgressBar>
      </div>
    </AppTooltip>
  );
};

export default ExportProgress;
